import React, { createContext, useContext } from "react";
import WhatsAppButton from "./WhatsappButton";

interface WhatsAppContextProps {
  phoneNumber: string;
  message?: string;
}

const WhatsAppContext = createContext<WhatsAppContextProps | null>(null);

export const WhatsAppProvider: React.FC<WhatsAppContextProps & { children: React.ReactNode }> = ({
  phoneNumber,
  message,
  children,
}) => {
  return (
    <WhatsAppContext.Provider value={{ phoneNumber, message }}>
      {children}
      <WhatsAppButton phoneNumber={phoneNumber} message={message} />
    </WhatsAppContext.Provider>
  );
};

// Custom Hook to use the WhatsApp context
export const useWhatsApp = () => {
  const context = useContext(WhatsAppContext);
  if (!context) {
    throw new Error("useWhatsApp must be used within a WhatsAppProvider");
  }
  return context;
};
